(function () {
  'use strict';

  /* @ngdoc object
   * @name crewExpiryLogReport
   * @description
   *
   */
  angular
    .module('crewExpiryLogReport', [
      'ui.router'
    ]);
}());
